export default __webpack_public_path__ + "static/media/014-road sign.c9f36b01.svg";